import React, { useState } from "react";
import ModalWrapper from "../../../app/common/modals/ModalWrapper";
import { Button, Container } from "semantic-ui-react";
import { closeModal } from "../../../app/common/modals/modalReducer";
import { useDispatch, useSelector } from "react-redux";
import { updateFieldOnDoc } from "../../../app/firestore/firestoreService";
import { FIRESTORE_APPLICATIONS_COLLECTION } from "../../../app/firestore/firestoreConstants";

export default function DeleteApplicationConfirmModal({ application }) {
  const dispatch = useDispatch();

  const { currentUserAccount } = useSelector((state) => state.account);
  const { responsive } = useSelector((state) => state.app);

  const [isSubmitting, setIsSubmitting] = useState(false);

  async function handleConfirmDelete() {
    if (application.employerId !== currentUserAccount.id) return;
    try {
      setIsSubmitting(true);
      await updateFieldOnDoc({
        dbCollection: FIRESTORE_APPLICATIONS_COLLECTION,
        id: application.id,
        key: "isDeletedByEmployer",
        value: true,
      });
    } catch (error) {
      console.log("error");
    } finally {
      setIsSubmitting(false);
      dispatch(closeModal());
    }
  }

  return (
    <ModalWrapper
      style={{ padding: 0, width: responsive.isMobile ? "96%" : "fit-content" }}
      modalClassName="modal-ux-wrapper"
      showAnimation={"fade"}
      hideAnimation={"fade"}
      showDuration={200}
      hideDuration={100}
    >
      <div className="confirm-action-modal">
        <Container textAlign="center">
          <div className="body-blue-text">Confirm to delete application</div>
          <div className="smaller-text" style={{ marginTop: 10 }}>
            This action cannot be undone.
          </div>
          <div style={{ marginTop: 30 }}>
            <Button
              className="overwrite-button confirm-action-button orange-inverse-button"
              style={{ marginRight: responsive.isMobile ? 5 : 20 }}
              content={"No, keep it"}
              onClick={() => dispatch(closeModal())}
            />
            <Button
              className="overwrite-button cta-orange"
              onClick={handleConfirmDelete}
              content={"Yes, delete"}
              loading={isSubmitting}
            />
          </div>
        </Container>
      </div>
    </ModalWrapper>
  );
}
